import { ConstructionStage, Contact } from "./index";

export class CommunityDetail {
    lotBlock: string;
    jobId: number;
    scarStage: ConstructionStage;
    scarStageDescription: string;
    phaseRelease: string;
    ownerName: string;
    ownerAddress: string;
    ownerAddress2: string;
    fieldContacts: Contact[];
    fieldContactNames: string;
    planTemplate: string;
    elevationHanding: string;
    handingIconClass: string;
    estFinish: Date;
    currentTask: string;
    daysBehind: number;
    prodType: string;
    scheduleIsActive: boolean;
    lastUpdatedDateTime: string;
    isUnscheduledJIO: boolean;
    hasGenericCOs: boolean;
    hasApprovedCOsWIthin36Hours: boolean;
    hasApprovedCOsWIthin120Hours: boolean;
    hasPlanChange: boolean;
    homesiteTransferIndicator: boolean;
    cancellationIndicator: boolean;
    nonStandardIndicator: boolean;
    hasHandingCOs: boolean;
    hasPaymentHold: boolean;
    lastChangeOrderUTC: Date;
    openRecordableIndicator: boolean;
}
